export default __webpack_public_path__ + "static/media/Linked_List_Deletion_1.27c1cb83.gif";